import {Field} from 'formik';
import {KeyboardDatePicker} from 'formik-material-ui-pickers';
import React from 'react';

const DateDefault = ({
  label,
  field,
  fullWidth,
  required,
  disabledPast,
  disabled,
}: DateProps) => (
  <Field
    name={field}
    component={KeyboardDatePicker}
    label={label}
    fullWidth={fullWidth}
    required={required}
    inputVariant="outlined"
    variant="inline"
    views={['year', 'month', 'date']}
    format="dd/MM/yyyy"
    disablePast={disabledPast}
    disabled={disabled}
  />
);

interface DateProps {
  label: string;
  field: string;
  fullWidth: boolean;
  required: boolean;
  disabledPast: boolean;
  disabled: boolean;
}

export default DateDefault;
